var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en
var uiMask = require('angular-ui-mask')
var guid = require('aem-libs/src/guid')

angular.module('inputTextCmp', [uiMask])
  .component('inputText', {
    template: require('./input-text.component.tpl.html'),
    controller: InputTextCtrl,
    controllerAs: 'vm',
    bindings: {
      formField: '<',
      value: '=',
      onChanged: '&',
      tooltipLabel: '@',
      tooltipClass: '<'
    }
  })

InputTextCtrl.$inject = ['$timeout', 'i18n']

function InputTextCtrl ($timeout, i18n) {
  var vm = this
  var timer
  var delayAfterKeyUp = 1000

  vm.onChanged = onChanged
  vm.onFocused = false
  vm.onBlured = false
  vm.showLoading = false
  vm.uiMask = null
  vm.uiMaskPlaceholder = null
  vm.uiMaskPlaceholderChar = 'space'
  vm.minLength = null
  vm.maxLength = null
  vm.pattern = null
  vm.min = null
  vm.max = null

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)
    vm.id = 'field_' + vm.formField.id + '-' + guid()

    if (vm.formField.defaultValueI18N && !vm.value[vm.formField.id]) {
      vm.value[vm.formField.id] = vm.formField.defaultValueI18N
    }
    if (vm.formField.businessName && vm.formField.businessName !== 'url') {
      var valueFromUrl = getParameterByName(vm.formField.businessName)
      if (valueFromUrl) {
        vm.value[vm.formField.id] = valueFromUrl
      }
    }
    vm.uiOptions = {
      clearOnBlur: false,
      maskDefinitions: {
        '9': /\d/,
        '+': /\+/,
        'A': /[a-zA-Z]/,
        '*': /[a-zA-Z0-9]/
      }
    }
    setPattern()
    setUiMask()
    setUiMaskPlaceholder()
    setMinLength()
    setMaxLength()
    setMin()
    setMax()
  }

  vm.$onChanges = function (changesObj) {
    if (changesObj.formField) {
      vm.type = getType()
    }
  }

  vm.onKeyDown = function (event) {
    if (isNumber()) {
      var charCode = (event.which) ? event.which : event.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105) && (charCode !== 86 && event.ctrlKey !== true)) {
        event.preventDefault()
      } else {
        $timeout.cancel(timer)
        vm.showLoading = true
      }
    } else {
      $timeout.cancel(timer)
      vm.showLoading = true
    }
  }

  vm.onKeyUp = function () {
    timer = $timeout(function () {
      vm.showLoading = false
    }, delayAfterKeyUp)
  }

  vm.onFocus = function () {
    $timeout(function () {
      vm.onFocused = true
      vm.onBlured = false
    }, 0)
    if (isPhoneNumber()) {
      setCaretPositionAfterIntPrefix()
    }
  }

  vm.onBlur = function () {
    $timeout(function () {
      vm.onFocused = false
      vm.onBlured = true
    }, 0)
  }

  function getType () {
    if (vm.formField.hidden) {
      return 'hidden'
    } else if (vm.formField.validation && vm.formField.validation.validationType === 'tel.Bez1/8') {
      return 'tel'
    } else if (vm.formField && vm.formField.validation && vm.formField.validation.validationType === 'cislo') {
      return 'tel'
    } else {
      return 'text'
    }
  }

  function getMin () {
    if (isNumber()) {
      return vm.formField.minimumValue
    }
  }

  function setMin () {
    vm.min = getMin()
  }

  function getMax () {
    if (isNumber()) {
      return vm.formField.maximumValue !== 0 ? vm.formField.maximumValue : null
    }
  }

  function setMax () {
    vm.max = getMax()
  }

  function getMinLength () {
    if (isRodneCislo() || isPostCode() || isPhoneNumber() || isNumber()) {
      return null
    } else if (vm.formField.validation && vm.formField.validation.minLength) {
      return vm.formField.validation.minLength
    } else {
      return null
    }
  }

  function setMinLength () {
    vm.minLength = getMinLength()
  }

  function getMaxLength () {
    if (isRodneCislo() || isPostCode() || isPhoneNumber() || isNumber()) {
      return null
    } else if (vm.formField.validation && vm.formField.validation.maxLength) {
      return vm.formField.validation.maxLength
    } else {
      return null
    }
  }

  function setMaxLength () {
    vm.maxLength = getMaxLength()
  }

  function getUiMask () {
    if (isPostCode()) {
      return '999 99'
    } else if (isRodneCislo()) {
      return '9 9 9 9 9 9 / 9 9 9 ?9'
    } else if (isPhoneNumber()) {
      return '+999 999 999 999'
    } else {
      return null
    }
  }

  function setUiMask () {
    vm.uiMask = getUiMask()
  }

  function getUiMaskPlaceholder () {
    if (isPhoneNumber()) {
      return '+420 ___ ___ ___'
    } else if (isPostCode()) {
      return '--- --'
    } else {
      return null
    }
  }

  function setUiMaskPlaceholder () {
    vm.uiMaskPlaceholder = getUiMaskPlaceholder()
  }

  function setPattern () {
    vm.pattern = showPattern() ? vm.formField.validation.regexp : null
  }

  function showPattern () {
    return (!(isRodneCislo() || isPostCode() || isPhoneNumber() || !vm.formField.validation || !vm.formField.validation.regexp))
  }

  function isRodneCislo () {
    return !!(vm.formField.validation && vm.formField.validation.validationType === 'rodnecislo')
  }

  function isPostCode () {
    return !!(vm.formField.validation && vm.formField.validation.validationType === 'PSC')
  }

  function isPhoneNumber () {
    return !!(vm.formField.validation && vm.formField.validation.validationType === 'tel.cislo')
  }

  function isNumber () {
    return !!(vm.formField && vm.formField.validation && vm.formField.validation.validationType === 'cislo')
  }

  function isModuloValid (birthNumber) {
    var modulo = birthNumber % 11
    return modulo === 0
  }

  function onChanged () {
    if (isRodneCislo()) {
      var isValidBirthNumber = null
      if (vm.value[vm.formField.id] && vm.value[vm.formField.id].length === 10) {
        isValidBirthNumber = isModuloValid(vm.value[vm.formField.id])
      } else if (vm.value[vm.formField.id] && vm.value[vm.formField.id].length === 9) {
        var isLessThan54 = !!(vm.value[vm.formField.id].substring(0, 2) < 54)
        if (isLessThan54) {
          isValidBirthNumber = true
        } else {
          isValidBirthNumber = isModuloValid(vm.value[vm.formField.id])
        }
      } else {
        isValidBirthNumber = null
      }
      vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('invalid_birthNumber_modulo', isValidBirthNumber)
    } else if (isNumber() && vm.formField.maximumValue !== 0) {
      vm.value[vm.formField.id] = vm.value[vm.formField.id].replace(/\D/g, '')
      var isMaxValueValid = !(vm.value[vm.formField.id] > vm.max)
      vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('invalid_maxValue', isMaxValueValid)
    }

    $timeout(function () {
      vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('invalidDefault', true)
    }, 0)
  }

  function getParameterByName (name, url) {
    if (!url) url = window.location.href
    name = name.replace(/[[\]]/g, '\\$&')
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    var results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  function setCaretPositionAfterIntPrefix () {
    // ui-mask fix
    var input = document.getElementById(vm.id)
    var pos = 5
    if (input.setSelectionRange) {
      input.setSelectionRange(pos, pos)
      $timeout(function () {
        input.setSelectionRange(pos, pos)
      })
    }
  }
}
